import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const bfrsClassPrefix = "bfrs-";
const negativeBfrsClassPrefix = "-bfrs-";

const bfrsTwMerge = extendTailwindMerge({
  experimentalParseClassName: ({ className, parseClassName }) => {
    const parsed = parseClassName(className);
    const { baseClassName } = parsed;

    if (baseClassName.startsWith(bfrsClassPrefix)) {
      return {
        ...parsed,
        baseClassName: baseClassName.slice(bfrsClassPrefix.length)
      };
    }

    if (baseClassName.startsWith(negativeBfrsClassPrefix)) {
      return {
        ...parsed,
        baseClassName: `-${baseClassName.slice(negativeBfrsClassPrefix.length)}`
      };
    }

    return {
      ...parsed,
      isExternal: true
    };
  }
});

export function cn(...inputs: ClassValue[]) {
  return bfrsTwMerge(clsx(inputs));
}
